// extracted by mini-css-extract-plugin
module.exports = {"input":"InputFull_input__1Tm-0","error_text":"InputFull_error_text__2N2wI","inp":"InputFull_inp__JEHiZ","but":"InputFull_but__323al"};